<template>
  <div>Landing page</div>
</template>

<script>
export default {

}
</script>